import { render } from "./PostMarketPhase.vue?vue&type=template&id=49b50a19"
import script from "./PostMarketPhase.vue?vue&type=script&lang=js"
export * from "./PostMarketPhase.vue?vue&type=script&lang=js"

import "./PostMarketPhase.vue?vue&type=style&index=0&id=49b50a19&lang=scss"
script.render = render

export default script